import React, { useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Swal from 'sweetalert2';
import { ShoppingCart, CreditCard, ArrowLeft, Package, Tag } from 'lucide-react';
import { API_URL } from "./config"; 
import 'bootstrap/dist/css/bootstrap.min.css';

const API_URL_STORE = "http://localhost:3009"; 

const CheckOut = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const { state } = useLocation();
  const cart = state?.cart || [];

  const userDetails = JSON.parse(localStorage.getItem("user")) || {};
  console.log("User Details:", userDetails);

  const totalAmount = cart.reduce((sum, item) => sum + (item.selling_price * item.quantity), 0);

  const styles = {
    primary: '#2C3E50',
    secondary: '#34495E',
    accent: '#3498DB',
    background: '#F8F9FA',
    headerGradient: 'linear-gradient(90deg, #2C3E50, #34495E)',
    success: '#2ECC71',
    warning: '#E67E22',
    error: '#E74C3C',
    cardBg: '#FFFFFF',
    textPrimary: '#2C3E50',
    textSecondary: '#7F8C8D',
    border: '#BDC3C7'
  };

  const saleOne = async (saleData) => {
    console.log("Posting to /salelist/ endpoint:", saleData);
    try {
      const saleResponse = await fetch(`http://localhost:3009/salelist/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(saleData),
      });

      if (!saleResponse.ok) {
        const errorText = await saleResponse.text();
        console.error('Sale endpoint error response:', errorText);
        throw new Error(`Sale endpoint error: ${errorText}`);
      }

      const result = await saleResponse.json();
      console.log("Sale endpoint response:", result);
      return result;
    } catch (error) {
      console.error('Sale endpoint error:', error);
      throw error;
    }
  };

  const payoutTrue = async () => {
    const tripItem = {
      driver_id: "", 
      cust_id: userDetails.userid, 
      request_start_datetime: new Date().toISOString(),
      order_start_datetime: new Date().toISOString(),
      estimate_order_end_datetime: null,
      order_end_datetime: "",
      status: "Just In",
      delivery_contact_details: "263777494960", 
      dest_location: "62F7+F92, Harare, Zimbabwe", 
      origin_location: "143 Cnr Five Avenue, Fifth St, Harare, Zimbabwe", 
      origin_location_lat: -17.819546,
      origin_location_long: 31.054026,
      destination_lat: " ",
      destination_long: " ",
      distance: 7.9,
      delivery_cost_proposed: 5,
      accepted_cost: 5,
      paying_when: " ",
      payment_type: "Cash",
      preferred_gender: "Any",
      preferred_car_type: " ",
      preferred_age: "Any",
      number_of_passengers: "Any",
      delivery_notes: "",
      delivery_volume: null,
      delivery_weight: null,
      commercial_value_delivery_category: " ",
      currency_id: "USD",
      currency_symbol: "$",
      trip_priority_type: null,
      delivery_received_confirmation_code: "0",
      customer_comment: null,
      driver_comment: null,
    };

    console.log("Posting to /trip/ endpoint:", tripItem);
    try {
      const response = await fetch(`https://srv547457.hstgr.cloud:3011/trip`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(tripItem),
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Trip endpoint error response:", errorText);
        throw new Error(`Trip endpoint error: ${errorText}`);
      }

      const result = await response.json();
      console.log("Trip endpoint response:", result);
      return result; 
    } catch (error) {
      console.error("Trip endpoint error:", error);
      throw error;
    }
  };

  const handleConfirmCheckout = async () => {
    try {
      setIsProcessing(true);
      Swal.fire({
        title: 'Processing Order',
        html: 'Please wait while we process your order...',
        allowOutsideClick: false,
        background: styles.cardBg,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const groupedItems = cart.reduce((acc, item) => {
        const { branch_id } = item;
        if (!acc[branch_id]) acc[branch_id] = [];
        acc[branch_id].push(item);
        return acc;
      }, {});

      for (const branchId in groupedItems) {
        const items = groupedItems[branchId];

        const salePostTransData = {
          propertyid: "",
          company_id: items[0]?.company_id || "",
          branch_id: branchId || "",
          project: "",
          daterec: new Date().toISOString().split("T")[0],
          timerec: new Date().toTimeString().split(" ")[0],
          datefor: new Date().toISOString().split("T")[0],
          description: "XGo Market Place",
          quantity: items.reduce((total, item) => total + item.quantity, 0),
          combined_receipt_total_quantity: items.reduce(
            (total, item) => total + item.quantity,
            0
          ),
          amntrec: totalAmount,
          amntrec_credit: 0.0,
          interest: 0.0,
          principal: 0.0,
          deposit: 0.0,
          balance: 0.0,
          receipt_ref_dispatch_locked: "UNLOCKED",
          feesdue: 0.0,
          username: userDetails.username || "XGO_store",
          confirmed_by: userDetails.id || "AUTO",
          authorized_by: "AUTO",
          branch: items[0]?.branch_name || "",
          dispatch_status: "DISPATCHED",
          dispatch_by: userDetails.id || "AUTO",
          dispatch_date: new Date().toISOString().split("T")[0],
          dispatch_time: new Date().toTimeString().split(" ")[0],
          dispatched_quantity: 0,
          undispatched_quantity_remaining: 0,
          undispatched_inventory_release_date: "0000-00-00",
          dispatch_sales_shift_id: "",
          sales_shifts_id: "",
          folio: "CAS",
          pmode: "CASH",
          currency: "USD",
          price: 0.0,
          usd_price: 0.0,
          usd_cost_per_unit: 0.0,
          credit_repayment_currency_price: 0.0,
          ref: "00000",
          vat_rate_charged: 0.0,
          vat_invoice_no: "00000",
          discount_requisition_id: "0",
          discount_amount: 0.0,
          discount_cost: 0.0,
          monthsbehind: 0,
          movementafterpayment: 0,
          suspencebal: 0.0,
          suspencedr: 0.0,
          suspencecr: 0.0,
          suspencenarration: "0.00",
          marketing_media_sale_origin: "Online Market Place",
          marketing_loyalty_structure_id: "00000",
          customerid: userDetails.id || 1,
          comment: "00000",
          sync_status: "00000",
        };

        console.log("Posting to /salepostrans/add_sale_pos_trans_sold endpoint:", salePostTransData);
        const response = await fetch(
          `${API_URL_STORE}/salepostrans/add_sale_pos_trans_sold`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(salePostTransData),
          }
        );

        if (!response.ok) {
          const errorText = await response.text();
          console.error('Sale post trans endpoint error response:', errorText);
          throw new Error("Sale post trans endpoint error: " + errorText);
        }

        const result = await response.json();
        console.log("Sale post trans endpoint response:", result);
        const currentTrans = result.result.insertId; // Assumed to be returned

        // Posting each sale record
        for (const product of items) {
          const saleRecord = {
            list_item_id: product.list_item_id,
            sale_records_id: currentTrans,
            product_id: product.product_id, // Ensure this is defined
            sale_date: new Date().toISOString(),
            sale_time: new Date().toTimeString(),
            quantity: product.quantity,
            unit_cost: product.unit_cost, // Ensure this is defined
            selling_price: product.selling_price,
            company_id: product.company_id,
            branch_id: product.branch_id,
            driver_confirmation_code1: Math.floor(100000 + Math.random() * 900000).toString(),
            driver_confirmation_code2: Math.floor(100000 + Math.random() * 900000).toString(),
            trip_id: currentTrans,
          };

          console.log("Posting to sale_list_item endpoint:", saleRecord);
          const sale_Record = await saleOne(saleRecord);
          if (!sale_Record) {
            throw new Error('Error during sale record submission');
          }
        }
      }

      await payoutTrue();

      Swal.fire({
        icon: 'success',
        title: 'Order Confirmed!',
        text: 'Your order has been successfully processed.',
        confirmButtonColor: styles.success,
        background: styles.cardBg,
      });

    } catch (error) {
      console.error('Checkout error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'An error occurred during checkout',
        confirmButtonColor: styles.error,
        background: styles.cardBg,
      });
    } finally {
      setIsProcessing(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0 }}
      className="container my-5"
    >
      <div className="card shadow-lg border-0" style={{ borderRadius: '15px', overflow: 'hidden', background: styles.cardBg }}>
        <div className="card-header py-4" style={{ background: styles.headerGradient }}>
          <div className="d-flex align-items-center">
            <ShoppingCart size={28} className="me-3 text-white" />
            <h2 className="mb-0 text-white" style={{ fontWeight: '600' }}>Order Summary</h2>
          </div>
        </div>

        <div className="card-body">
          {cart.length === 0 ? (
            <motion.div 
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              className="text-center py-5"
            >
              <ShoppingCart size={72} style={{ color: styles.primary }} className="mb-3" />
              <h3 style={{ color: styles.primary }}>Your cart is empty!</h3>
              <Link 
                to="/" 
                className="btn mt-3"
                style={{ 
                  background: styles.headerGradient,
                  color: 'white',
                  padding: '10px 25px',
                  borderRadius: '8px'
                }}
              >
                <ArrowLeft size={18} className="me-2" />
                Continue Shopping
              </Link>
            </motion.div>
          ) : (
            <>
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead>
                    <tr style={{ background: styles.background }}>
                      <th className="py-3">Product ID</th>
                      <th className="py-3">Product</th>
                      <th className="py-3">Category</th>
                      <th className="py-3">Price</th>
                      <th className="py-3">Quantity</th>
                      <th className="py-3">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cart.map(item => (
                      <motion.tr
                        key={item.product_id}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.3 }}
                        style={{ borderBottom: `1px solid ${styles.border}` }}
                      >
                        <td className="align-middle py-3">{item.product_id}</td>
                        <td className="align-middle py-3">
                          <div className="d-flex align-items-center">
                            <Package size={20} className="me-2" style={{ color: styles.primary }} />
                            {item.product_name}
                          </div>
                        </td>
                        <td className="align-middle">
                          <span className="badge" style={{ background: styles.primary, padding: '8px 12px' }}>
                            <Tag size={14} className="me-1" />
                            {item.category}
                          </span>
                        </td>
                        <td className="align-middle">${item.selling_price.toFixed(2)}</td>
                        <td className="align-middle">
                          <span className="badge bg-white text-dark border" style={{ padding: '8px 12px' }}>
                            {item.quantity}
                          </span>
                        </td>
                        <td className="align-middle fw-bold" style={{ color: styles.primary }}>
                          ${(item.selling_price * item.quantity).toFixed(2)}
                        </td>
                      </motion.tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr style={{ background: styles.background }}>
                      <td colSpan="5" className="text-end fw-bold py-3">Total Amount:</td>
                      <td className="fw-bold py-3" style={{ color: styles.primary, fontSize: '1.2em' }}>
                        ${totalAmount.toFixed(2)}
                      </td>
                    </tr>
                  </tfoot>
                </table>
              </div>

              <div className="d-flex justify-content-between align-items-center mt-4">
                <Link 
                  to="/" 
                  className="btn"
                  style={{ 
                    border: `2px solid ${styles.primary}`,
                    color: styles.primary,
                    padding: '10px 25px',
                    borderRadius: '8px'
                  }}
                >
                  <ArrowLeft size={18} className="me-2" />
                  Continue Shopping
                </Link>
                
                <motion.button
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                  className="btn btn-lg"
                  onClick={handleConfirmCheckout}
                  disabled={isProcessing}
                  style={{ 
                    background: styles.headerGradient,
                    color: 'white',
                    padding: '12px 30px',
                    borderRadius: '8px'
                  }}
                >
                  <CreditCard size={20} className="me-2" />
                  {isProcessing ? 'Processing...' : 'Confirm Order'}
                </motion.button>
              </div>
            </>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default CheckOut;